/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Page_TitleInputs */

const tr_faq_page_title = /** @type {(inputs: Faq_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sık Sorulan Sorular`)
};

const en_faq_page_title = /** @type {(inputs: Faq_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frequently Asked Questions`)
};

const de_faq_page_title = /** @type {(inputs: Faq_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Häufige Fragen`)
};

const ru_faq_page_title = /** @type {(inputs: Faq_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Частые вопросы`)
};

/**
* | output |
* | --- |
* | "Frequently Asked Questions" |
*
* @param {Faq_Page_TitleInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const faq_page_title = /** @type {((inputs?: Faq_Page_TitleInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Page_TitleInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_faq_page_title(inputs)
	if (locale === "de") return de_faq_page_title(inputs)
	if (locale === "ru") return ru_faq_page_title(inputs)
	return tr_faq_page_title(inputs)
});